import React, { useRef, useEffect, useState } from 'react';
import Webcam from 'react-webcam';
import { logEvent, putSelfieInStorage } from '../helpers/firebase';
import { useGlobalContext } from './globalContext';
import ImageFilter from 'react-image-filter'

interface Step3Props {
    onStepCompleted: () => void;
}

export const Step3: React.FC<Step3Props> = ({ onStepCompleted }) => {
    const webcamRef = useRef<Webcam>(null);
    const [snapshot, setSnapshot] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);
    const { setMyPicture } = useGlobalContext();



    useEffect(() => {
        const startWebcam = async () => {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });

                if (webcamRef.current) {
                    const videoElement = webcamRef.current.video;
                    if (videoElement) {
                        videoElement.srcObject = stream;
                        setError(null);
                    } else {
                        console.log('videoElement is null');
                    }
                } else {
                    console.log('webcamRef is null');
                }
            } catch (error) {
                if ((error as Error).name === 'NotFoundError') {
                    console.error('Step 3: No webcam found.');
                    setError("Geen webcam gevonden. Weet je zeker dat je een webcam hebt (aangesloten?)");
                } else if ((error as Error).name === 'NotAllowedError') {
                    console.error('Step 3: User denied access to the webcam.');
                    setError("Je hebt deze website geen toegang gegeven tot je webcam. Wellicht heb je de toestemming popup weggeklikt? Google dan even hoe je deze website weer toegang geeft.");
                } else if ((error as Error).name === 'NotReadableError') {
                    console.error('Step 3: Could not access the webcam. It may already be in use.');
                    setError("Je webcam is al in gebruik door een andere apllicatie of website. Sluit deze eerst af.");
                } else {
                    console.error('Error accessing webcam:', error);
                    setError("Er is een fout opgetreden bij het openen van je webcam. Probeer het later nog eens.");
                }
            }
        };

        startWebcam();

        return () => {
            // Clean up code if needed (stop the webcam stream)
        };
    }, []);

    const captureSnapshot = () => {
        logEvent("ClickTakeSnapshot", "");
        if (webcamRef.current) {
            //{width: 1920, height: 1080} --> possible to pass this in getScreenshot, but ratio gets f*cked up
            let imageSrc = webcamRef.current.getScreenshot();
            if (imageSrc) {
                //imageSrc = applyFiltersToImageSyncSync(imageSrc)
                setSnapshot(imageSrc);
                setMyPicture(imageSrc);
                putSelfieInStorage(imageSrc);
            }
        }
    };

    const videoConstraints = {
        facingMode: "user"
    };

    return (
        <div>
            <div className="flex flex-col">
                <p className="text-l font-bold">Maak een leuke 'popart' foto!</p>
                {!snapshot && (
                <p className="text-s mt-2 text-gray-600">Maak een hier selfie! Het resultaat is een zonnige popart versie waarvan wij één grote collage gaan maken. Probeer gerust een paar keer voor je beste look! </p>
                )}
                <div className="bg-slate-50 border-t-4  text-justify rounded-b text-slate-700 px-4 py-3 shadow-md my-3 ">
                    <div>
                        {
                            webcamRef == null ? (
                                <div role="status" className="center py-2">
                                    <svg aria-hidden="true" className=" w-8 h-8  text-gray-200 animate-spin fill-primary" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="white" />
                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                    </svg>
                                    <span className="sr-only">Laden...</span>
                                </div>
                            ) : ""
                        }
                        {error != null && (
                            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
                                <strong className="font-bold">Oeps er ging iets mis!</strong>
                                <br></br>
                                <span className="block sm:inline break-word text-justify">{error}</span>

                            </div>
                        )}
                        <Webcam
                            audio={false}
                            // screenshotFormat="image/jpeg"
                            videoConstraints={videoConstraints}
                            minScreenshotHeight={720}
                            screenshotQuality={1}
                            style={{ filter: '' }} ref={webcamRef} />
                    </div>
                </div>
                <button onClick={(e) => captureSnapshot()}
                    className="rounded-md bg-backgroundcolor border border-primary p-4 text-center my-4 px-3.5 py-2.5 text-s font-semibold text-black shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">
                    ↓ Maak foto! ↓
                </button>
                {snapshot && (
                    <div>
                        <p className="font-bold">Dit is jouw kiekje!</p>
                        <div className="bg-slate-50 border-t-4  text-justify rounded-b text-slate-700 px-4 py-3 shadow-md my-3 " role="alert">
                            <div className="flex" id="filteredImage2">
                                <div>

                                    <ImageFilter
                                        image={snapshot}
                                        //className="contrast-200"
                                        id="filteredImage"
                                        filter={'duotone'}
                                        colorTwo={[255, 255, 255]}
                                        // colorTwo = {[235, 179, 40]}
                                        colorOne={[250, 204, 21]}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                )
                }
            </div>
        </div>
    );
};